import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/img/default-avatar.png'
import _imports_1 from '../../assets/img/unlink-line-icon.png'


const _withScopeId = n => (_pushScopeId("data-v-f4e01496"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "account-info-section" }
const _hoisted_2 = { class: "account-info-profile" }
const _hoisted_3 = ["src"]
const _hoisted_4 = {
  key: 1,
  class: "account-info-avatar",
  src: _imports_0,
  alt: "Avatar"
}
const _hoisted_5 = { class: "account-info-group" }
const _hoisted_6 = { class: "account-info-name" }
const _hoisted_7 = {
  key: 0,
  class: "account-info-mobile"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "แก้ไขโปรไฟล์ของฉัน", -1))
const _hoisted_9 = { class: "arrow" }
const _hoisted_10 = { class: "account-info-data" }
const _hoisted_11 = {
  key: 0,
  class: "account-info-data-card points-section"
}

export function render(_ctx, _cache) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")
  const _component_ClubcardLoyalty = _resolveComponent("ClubcardLoyalty")

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.lineInfo.profile.pictureUrl)
        ? (_openBlock(), _createElementBlock("img", {
            key: 0,
            class: "account-info-avatar",
            src: _ctx.lineInfo.profile.pictureUrl,
            alt: "Avatar"
          }, null, 8, _hoisted_3))
        : _createCommentVNode("", true),
      (!_ctx.lineInfo.profile.pictureUrl)
        ? (_openBlock(), _createElementBlock("img", _hoisted_4))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("span", null, _toDisplayString(_ctx.lineInfo.profile.displayName), 1),
          (_ctx.customer.customerType === 'online')
            ? (_openBlock(), _createElementBlock("img", {
                key: 0,
                class: "account-info-unlink",
                src: _imports_1,
                onClick: _cache[0] || (_cache[0] = $event => (_ctx.openModalUnlinkConfirmation()))
              }))
            : _createCommentVNode("", true)
        ]),
        (_ctx.customer.customerType === 'online')
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(_ctx.getSeparatedPhoneNumber()), 1))
          : _createCommentVNode("", true),
        (_ctx.customer.customerType === 'loyalty')
          ? (_openBlock(), _createElementBlock("div", {
              key: 1,
              class: "account-info-edit-profile",
              onClick: _cache[1] || (_cache[1] = $event => (_ctx.openModalEditProfile()))
            }, [
              _hoisted_8,
              _createElementVNode("button", _hoisted_9, [
                _createVNode(_component_font_awesome_icon, { icon: "fa-solid fa-chevron-right" })
              ])
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_10, [
      (_ctx.customer.customerType === 'online' || _ctx.customer.customerType === 'loyalty')
        ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
            _createVNode(_component_ClubcardLoyalty, {
              forceUpdate: _ctx.forceUpdate,
              openModalBarcode: _ctx.openModalBarcode
            }, null, 8, ["forceUpdate", "openModalBarcode"])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}